import { makeVar, useReactiveVar } from '@apollo/client'
import { PendingActions } from 'queries/get-deal-open-actions'

export const pendingActionsDecisionStatusVar = makeVar<PendingActions[]>([])

const defaultActions = undefined

export function setPendingActionsDecisionStatus(pendingActions: PendingActions[]) {
  // notification issue. As per Appolo client library documentation we need to pass a new copy instead of mutatating an existing object or array.
  pendingActionsDecisionStatusVar([...pendingActions])
}

export function useGetPendingActionsDecisionStatus(): PendingActions[] | undefined {
  const pendingActionsMapping = useReactiveVar(pendingActionsDecisionStatusVar)
  return pendingActionsMapping || defaultActions
}
